import Offline from 'pages/Offline';
import { Box, useMediaQuery } from '@material-ui/core';
import { useOnlineStatus } from 'Hook/General/useOnlineStatus';

const withOfflineMode = (ComposedComponent) => {
	return (hocProps) => {
		const isOnlineMode = useOnlineStatus();
		const matches = useMediaQuery('(min-width:480px)');

		if (isOnlineMode === false) {
			return (
				<div {...(matches && { id: 'mobile-view' })}>
					<Offline />
					<Box display="none">
						<ComposedComponent {...hocProps} />
					</Box>
				</div>
			);
		}

		return <ComposedComponent {...hocProps} />;
	};
};

export default withOfflineMode;
